import {
  BOOKING_BASE_PATH,
} from 'settings'

export const hostname = () => window.location.origin
export const projectUrl = (project) => project ? (project.url || project.id) : null
export const bookingFormUrl = (bookingForm) => bookingForm ? (bookingForm.url || bookingForm.id) : null
export const fullUrl = (project, bookingForm) => [hostname(), BOOKING_BASE_PATH, projectUrl(project), bookingFormUrl(bookingForm)].filter(p => p).join('/')